export default "__VITE_ASSET__BoG1__0L__"